let currentLocale = "nl-NL"

export function fNumber(number: string | number, formatting = "0.00"): string {
  const num = typeof number === "string" ? parseFloat(number) : number
  if (isNaN(num)) return ""

  const decimals = formatting.split(".")[1]?.length || 0
  const formatter = new Intl.NumberFormat(currentLocale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })

  return formatter.format(num)
}

export function fCurrency(number: string | number, isoCode = "EUR", formatting = `$0,0`): string {
  const num = typeof number === "string" ? parseFloat(number) : number
  if (isNaN(num)) return ""

  const decimals = formatting.includes(".")
    ? formatting.split(".")[1]?.replace(/[^0]/g, "").length || 0
    : 0
  const formatter = new Intl.NumberFormat(currentLocale, {
    style: "currency",
    currency: isoCode,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    currencyDisplay: "narrowSymbol",
  })

  return formatter.format(num)
}

export function fPercent(number: string | number, formatting = "0.0%"): string {
  if (!number) return ""

  const num = typeof number === "string" ? parseFloat(number) : number
  if (isNaN(num)) return ""

  const decimals = formatting.split(".")[1]?.replace("%", "").length || 0
  const formatter = new Intl.NumberFormat(currentLocale, {
    style: "percent",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })

  return formatter.format(num)
}

export function fShortenNumber(number: string | number): string {
  if (!number) return ""

  const num = typeof number === "string" ? parseFloat(number) : number
  if (isNaN(num)) return ""

  const formatter = new Intl.NumberFormat(currentLocale, {
    notation: "compact",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

  return formatter.format(num)
}

export function fData(number: string | number): string {
  const num = typeof number === "string" ? parseFloat(number) : number
  if (isNaN(num)) return ""

  const units = ["B", "KB", "MB", "GB", "TB"]
  let unitIndex = 0
  let value = num

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024
    unitIndex++
  }

  const formatter = new Intl.NumberFormat(currentLocale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })

  return `${formatter.format(value)} ${units[unitIndex]}`
}

export function stringToNumber(value: string): number | null {
  if (!value) return null

  // Handle Dutch locale format (. as thousands separator, , as decimal)
  const normalized = value.replace(/\./g, "").replace(",", ".")
  const num = parseFloat(normalized)

  return isNaN(num) ? null : num
}

export function setLocale(locale: string) {
  currentLocale = locale
}
